module.exports = __webpack_public_path__ + "img/YKM_Android.34e3f70b.png";